import * as Core from '@skylab-shared/core';
import { ConfigurationDocumentKind } from '../common/configuration-document-kind';
import { GapFillingMethod } from '../common/gap-filling-method';


export class NumberingModel extends Core.ModelBase {
    @Core.Property({ identifiable: true })
    public id: number;

    @Core.Property()
    public active: boolean;

    @Core.Property()
    @Core.NormalString('data-model.numberings.validation.additional-symbol.length')
    public additionalSymbol: string;

    @Core.Property()
    public default: boolean;

    @Core.Property()
    public documentNumberInUse: boolean;

    @Core.Property()
    @Core.VeryLongString('data-model.numberings.validation.format.length')
    public format: string;

    @Core.Property()
    public gapFillingMethod: GapFillingMethod;

    @Core.Property()
    @Core.Required('data-model.numberings.validation.name.not-empty')
    @Core.ShortString('data-model.numberings.validation.name.length')
    public name: string;

    @Core.Property()
    public manual: boolean;

    @Core.Collection({ type: String })
    public kinds: (ConfigurationDocumentKind)[];

    @Core.Property()
    public startingNumber: number;

}
